import { render } from "./SubMenu.vue?vue&type=template&id=43552f0c&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=43552f0c&scoped=true&lang=css"
import "./SubMenu.vue?vue&type=style&index=1&id=43552f0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43552f0c"]])

export default __exports__